import { axios } from "../../../constants/axiosConfig";
import { message } from "antd";

// Retornar lista de produtos importados
export function getProduct(id) {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;

  return async (dispatch) => {
    dispatch({
      type: "GET_PRODUCT_REQUEST",
    });
    await axios
      .get(`produto/${id}/${cnpj}`)
      .then((response) => {
        dispatch({ type: "GET_PRODUCT_SUCCESS", payload: response.data });
      })
      .catch(() => dispatch({ type: "GET_PRODUCT_FAILURE" }));
  };
}

// Cadastrar novo produto
export function setProduct(data) {
  delete data.Id;
  data.Cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
  data.Produto.Ncm = data.Produto.Ncm.split(".").join("").split("_").join("");
  data.Produto.Cest = data.Produto.Cest.split(".").join("").split("_").join("");
  data.Produto.Ex = data.Produto.Ex.split("_").join("");

  return async (dispatch) => {
    dispatch({ type: "SET_PRODUCT_REQUEST" });
    await axios
      .post(`produto`, data)
      .then((response) => {
        dispatch({ type: "SET_PRODUCT_SUCCESS", payload: response.data });
        if (response.data?.StatusCode === 200) {
          message.success("Produto cadastrado com sucesso");
        }
      })
      .catch((error) => {
        dispatch({ type: "SET_PRODUCT_FAILURE" });
        if (error && error.response && error.response.status !== 403) {
          if (error.response.data.Mensagem === "EAN inválido") {
            message.error("EAN ou EX inválidos");
          } else {
            message.error("Não foi possível cadastrar o produto");
          }
        }
      });
    dispatch({ type: "PRODUCTS_CLEAN" });
  };
}

// Editar produto selecionado
export function putProduct(data) {
  data.Cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
  data.Produto.Ncm = data.Produto.Ncm.split(".").join("").split("_").join("");
  data.Produto.Cest = data.Produto.Cest.split(".").join("").split("_").join("");
  data.Produto.Ex = data.Produto.Ex.split("_").join("");

  return async (dispatch) => {
    dispatch({ type: "PUT_PRODUCT_REQUEST" });
    await axios
      .put(`produto/${data.Produto.Id}`, data)
      .then((response) => {
        dispatch({ type: "PUT_PRODUCT_SUCCESS", payload: response.data });
        if (response.data?.StatusCode === 200) {
          message.success("Produto atualizado com sucesso");
        }
      })
      .catch((error) => {
        dispatch({ type: "PUT_PRODUCT_FAILURE" });
        if (error && error.response && error.response.status !== 403) {
          if (error.response.data.Mensagem === "EAN inválido") {
            message.error("EAN ou EX inválidos");
            return
          } else {
            message.error("Não foi possível cadastrar o produto");
          }
        } else {
          message.error("Não foi possível cadastrar o produto");
        }
      });
    dispatch({ type: "PRODUCTS_CLEAN" });
  };
}

// Deletar produto selecionado
export function deleteProduct(ids, extraData, filter) {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
  let endpoint = `produto/${cnpj}/deletar`,
    data = {};

  data.Cnpj = cnpj;
  if (ids) {
    data.Ids = ids;
  }

  if (extraData) {
    if (extraData.status) {
      endpoint += `/${extraData.month}/${extraData.year}/${extraData.status}`;
    } else if (extraData.month && extraData.year) {
      endpoint += `/${extraData.month}/${extraData.year}`;
    }
  }

  return async (dispatch) => {
    dispatch({ type: "DELETE_PRODUCT_REQUEST" });
    await axios
      .post(endpoint + filter, data)
      .then((response) => {
        dispatch({ type: "DELETE_PRODUCT_SUCCESS", payload: response.data });
        if (response.data?.StatusCode === 200) {
          message.success("Produto(s) excluído(s) com sucesso");
        }
      })
      .catch((error) => {
        if (error && error.response && error.response.status !== 403) {
          message.error("Ocorreu algum problema ao deletar");
        }
        dispatch({ type: "DELETE_PRODUCT_FAILURE" });
      });
    dispatch({ type: "PRODUCTS_CLEAN" });
  };
}

// Considerar ou desconsiderar receita
export function considerRevenue(data, filters) {
  const filter = filters ? filters : "";
  const endpoint = "produto/considerarReceita";

  return async (dispatch) => {
    dispatch({ type: "CONSIDER_REVENUE_REQUEST" });
    await axios
      .post(endpoint + filter, data)
      .then((response) => {
        dispatch({
          type: "CONSIDER_REVENUE_SUCCESS",
          payload: response.data,
        });
        if (response.data?.StatusCode === 200) {
          message.success("Considerar receita alterado com sucesso");
        }
      })
      .catch((error) => {
        dispatch({ type: "CONSIDER_REVENUE_FAILURE" });
        if (error && error.response && error.response.status !== 403) {
          message.error("Não foi possível realizar a ação");
        }
      });
  };
}
